import axios from 'axios';

export function login(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        "accessToken": "dummyToken",
                        "refreshToken": "dummyToken"
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/login`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function sendForgetPasswordEmail(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        "accessToken": "dummyToken",
                        "refreshToken": "dummyToken"
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/forgetPassword`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function resetPasswordWithToken(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        "accessToken": "dummyToken",
                        "refreshToken": "dummyToken"
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/resetPassword`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function changePassword(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        "accessToken": "dummyToken",
                        "refreshToken": "dummyToken"
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/ChangePassword`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function searchUsers(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        "accessToken": "dummyToken",
                        "refreshToken": "dummyToken"
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/SearchUser`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function getRolesList(mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        test: 'testDataHere'
                    }
                });
            }, 2000);
        });
    } else {
        return axios.get(`/Authentication/GetUserRolesList`)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function getUserById(userId, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        test: 'testDataHere'
                    }
                });
            }, 2000);
        });
    } else {
        return axios.get(`/Authentication/getUserById/${userId}`)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function updateUser(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        test: 'testDataHere'
                    }
                });
            }, 2000);
        });
    } else {
        if (payload.userId === 0) {
            return axios.post(`/Authentication/RegisterUser`, payload)
                .then(res => (res))
                .catch(err => (err.response));
        } else {
            return axios.post(`/Authentication/updateUser`, payload)
                .then(res => (res))
                .catch(err => (err.response));
        }

    }
}

export function isEmailExist(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        test: 'testDataHere'
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/isEmailExist`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}

export function isUserNameExist(payload, mockMode = false) {
    if (mockMode === true) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    status: 200,
                    data: {
                        test: 'testDataHere'
                    }
                });
            }, 2000);
        });
    } else {
        return axios.post(`/Authentication/isUserNameExist`, payload)
            .then(res => (res))
            .catch(err => (err.response));
    }
}
